const Footer = ({className}) => {
    return (
        <div className={`Footer ${className || ''}`}>
            <div className="made-by">Made by <a href="https://caldwell.info">Dan Caldwell</a></div>
            <div className="privacy-policy"><a href="/privacy-policy">Privacy Policy</a></div>
        </div>
    )
}

export default Footer;